import { IActionTypes } from "./types";

export const name: "FEED" = "FEED";

export const ActionTypes: IActionTypes = {
  CONNECTION_START: `${name}/CONNECTION_START`,
  CONNECTION_SUCCESS: `${name}/CONNECTION_SUCCESS`,
  CONNECTION_ERROR: `${name}/CONNECTION_ERROR`,
  CONNECTION_CLOSED: `${name}/CONNECTION_CLOSED`,
  GET_ORDERS: `${name}/GET_ORDERS`,
  SEND_ORDERS: `${name}/SEND_ORDERS`,
  AUTH_CONNECTION_START: `${name}/AUTH_CONNECTION_START`,
  AUTH_CONNECTION_SUCCESS: `${name}/AUTH_CONNECTION_SUCCESS`,
  AUTH_CONNECTION_ERROR: `${name}/AUTH_CONNECTION_ERROR`,
  AUTH_CONNECTION_CLOSED: `${name}/AUTH_CONNECTION_CLOSED`,
  AUTH_GET_ORDERS: `${name}/AUTH_GET_ORDERS`,
  AUTH_SEND_ORDERS: `${name}/AUTH_SEND_ORDERS`,
};
